import CookieService from './general/cookie-service';

const ActiveGroupCacheService = {
  setCurrentGroupCookie(groupId: string) {
    CookieService.set('CRT_GRP_ID', groupId);
  },
  getCurrentGroupCookie() {
    return CookieService.get('CRT_GRP_ID') as string | undefined;
  },
  resetCurrentGroupCookie() {
    CookieService.delete('CRT_GRP_ID');
  },
};

export default ActiveGroupCacheService;
